export interface Lead {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  name: string;
  phone: string;
  email: string;
  content: string;
  status: LeadStatus;
  note: string;
}

export enum LeadStatus {
  Pending = "PENDING",
  Solve = "SOLVE",
}

export const LeadStatusTrans = {
  [LeadStatus.Pending]: {
    value: LeadStatus.Pending,
    label: "Chưa xử lý",
    color: "orange",
  },
  [LeadStatus.Solve]: {
    value: LeadStatus.Solve,
    label: "Đã xử lý",
    color: "blue",
  },
};
